// Manually update this map with brief release notes keyed by the deployed web version.
const releaseNotesMap: Record<string, string[]> = {
  // '1.2.3': ['Short description of the release.'],
  '1.30.0': [
    'New! Rollo Rewards: Earn discounts, perks, and exclusive rewards.',
    'New! Bank payments support.',
    'Improved email templates with multiple recipient support.',
    'Various performance improvements and bug fixes.',
  ],
  '1.31.0': ['Enhanced Rewards experience.', 'Various performance improvements and bug fixes.'],
  '1.32.0': [
    'New! Trusted login - faster, more secure sign-in that recognizes your trusted devices.',
    'New! Smarter order tracking - the pending orders list now refreshes automatically.',
    'New! Unified Search - find any order or shipment in one place by searching across the Orders and Shipped pages at once.',
    'New! Order updates history - see every change made to an order, and who made it, right on the order details page.',
    'New! Create a shipment directly from your Contacts.',
    'Now get notified the moment you unlock a rewards badge.',
    'Sync "Mark as Shipped" status back to your marketplace.',
    'Streamlined rewards - redeem your perks in fewer steps.',
    'Various performance improvements and bug fixes.',
  ],
};

export const getReleaseNotes = (version?: string | null) => {
  if (!version) return null;
  return releaseNotesMap[version] || null;
};

export default releaseNotesMap;
